import axios from 'axios';
import appConfig from '../config.js';
import store from '../store.js';
import { authorize, clearData, getPanelAccessToken } from '../auth/id-auth.js';

const panelApi = axios.create({
    baseURL: appConfig.apiUrl,
});

function resolvePanelAccessToken() {
    return getPanelAccessToken() || store.getters['auth/token'] || '';
}

export function syncPanelAuthFromStorage() {
    const token = resolvePanelAccessToken();
    if (token) {
        panelApi.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete panelApi.defaults.headers.common['Authorization'];
    }
    return token;
}

panelApi.interceptors.request.use(config => {
    const token = resolvePanelAccessToken();
    if (!config.headers) {
        config.headers = {};
    }
    if (token) {
        config.headers['Authorization'] = 'Bearer ' + token;
    }
    return config;
}, error => Promise.reject(error));

panelApi.interceptors.response.use(
    (response) => response,
    function (error) {
        const response = error?.response;
        if (!response) {
            return Promise.reject(error);
        }

        const originalRequest = error.config;
        const status = response.status;

        if (status === 401) {
            const details = response.data?.error?.details || {};
            const headerMissing = details.authorization_header_present === false;
            const token = resolvePanelAccessToken();
            const requestUrl = String(originalRequest?.url || '');
            const isConfigRequest = requestUrl.includes('/config');

            if (headerMissing && token && !originalRequest._authHeaderRetry) {
                originalRequest._authHeaderRetry = true;
                syncPanelAuthFromStorage();
                originalRequest.headers = originalRequest.headers || {};
                originalRequest.headers['Authorization'] = 'Bearer ' + token;
                return panelApi.request(originalRequest);
            }

            if (!isConfigRequest && !originalRequest._unauthorizedHandled) {
                originalRequest._unauthorizedHandled = true;
                clearData();
                authorize();
            }
        }

        return Promise.reject(error);
    }
);

export default panelApi;
